<template>
  <div class="form-inline mb-sm-3 d-flex align-items-end reports-container">
    <div class="d-flex col-12 col-md-auto px-0 mb-3 mb-md-2">
      <div class="filter pr-1">
        <div class="form-check pl-0">
          <input
            class="form-check-input"
            type="radio"
            name="reassignMode"
            id="reassignModeCompetitor"
            value="member"
            :checked="active === 'member'"
            @change="navigate('member')"
          />
          <label class="form-check-label" for="reassignModeCompetitor">Re-assign by competitor</label>
        </div>
      </div>
      <div class="filter">
        <div class="form-check pl-0">
          <input
            class="form-check-input"
            type="radio"
            name="reassignMode"
            id="reassignModeHorse"
            value="horse"
            :checked="active === 'horse'"
            @change="navigate('horse')"
          />
          <label class="form-check-label" for="reassignModeHorse">Re-assign by horse</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance } from '@vue/composition-api'

export default defineComponent({
  name: 'NominationReassignTabs',
  props: {
    draftId: { type: [String, Number], required: true },
    active: { type: String, default: 'member' }
  },
  setup(props) {
    const { proxy } = getCurrentInstance()

    const navigate = (mode) => {
      const path = mode === 'member'
        ? `/nominations/${props.draftId}/reassign-member`
        : `/nominations/${props.draftId}/reassign-horse`
      proxy.$router.push(path)
    }

    return { navigate }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Nominations/NominationReassignTabs.vue